import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'msd-audio-preview-cell',
  templateUrl: './audio-preview-cell.component.html',
  styleUrls: ['./audio-preview-cell.component.scss'],
})
export class AudioPreviewCellComponent implements OnInit {
  @Input() canBeRemoved = false;
  @Input() url: string;
  @Output() remove = new EventEmitter();

  public audioPlayer = new Audio();
  public playing = false;

  ngOnInit(): void {
    this.audioPlayer.src = this.url;
    this.audioPlayer.load();

    this.audioPlayer.onended = () => {
      this.playing = false;
    };
  }

  play() {
    this.playing = true;
    this.audioPlayer.play();
  }

  pause() {
    this.playing = false;
    this.audioPlayer.pause();
  }
}
